import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_TREASURY_MOVEMENTS = '[TREASURY MOVEMENTS] GET TREASURY MOVEMENTS'
export const SAVE_TREASURY_MOVEMENT = '[TREASURY MOVEMENTS] SAVE TREASURY MOVEMENT'
export const VOID_TREASURY_MOVEMENT = '[TREASURY MOVEMENTS] VOID TREASURY MOVEMENT'

export function getTreasuryMovementsAction(treasuryId) {
  const request = api.get(`/treasury-movements/${treasuryId}`)
  return (dispatch) => {
    dispatch({ type: GET_TREASURY_MOVEMENTS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_TREASURY_MOVEMENTS, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_TREASURY_MOVEMENTS, error)
    }).finally(() => {
      dispatch({ type: GET_TREASURY_MOVEMENTS, payload: { loading: false } })
    })
  }
}

export function saveTreasuryMovementAction(data) {
  const request = api.post('/treasury-movements/save', data)
  return (dispatch) => {
    dispatch({ type: SAVE_TREASURY_MOVEMENT, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_TREASURY_MOVEMENT, payload: { saved: true, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(SAVE_TREASURY_MOVEMENT, error)
    }).finally(() => {
      dispatch({ type: SAVE_TREASURY_MOVEMENT, payload: { saving: false } })
    })
  }
}

export function voidTreasuryMovementAction(treasuryId) {
  const request = api.put(`/treasury-movements/${treasuryId}/void`)
  return (dispatch) => {
    dispatch({ type: VOID_TREASURY_MOVEMENT, payload: { voiding_id: treasuryId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: VOID_TREASURY_MOVEMENT, payload: { voided_id: treasuryId, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(VOID_TREASURY_MOVEMENT, error)
    }).finally(() => {
      dispatch({ type: VOID_TREASURY_MOVEMENT, payload: { voiding_id: treasuryId } })
    })
  }
}